export enum PersistMethod {
  LocalStorage,
  SessionStorage,
  IndexedDB,
}
